import script from "./SiteNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteNav.vue?vue&type=script&setup=true&lang=ts"

import "./SiteNav.vue?vue&type=style&index=0&id=50f60efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f60efa"]])

export default __exports__